import errorMessages from 'utils/validation/errorMessages';
import * as Yup from 'yup';

const optionObjectShape = Yup.object({
    label: Yup.string(),
    value: Yup.string(),
});

const appointmentsValidationSchema = Yup.object().shape({
    title: Yup.string().required(errorMessages?.required),
    // appointment_reason: Yup.string().required(errorMessages?.required),
    parentLastname: Yup.string().required(errorMessages?.required),
    parentFirstname: Yup.string().required(errorMessages?.required),
    parentEmail: Yup.string()
        .email('Invalid email')
        .required(errorMessages?.required),
    parentPhone: Yup.string().required(errorMessages?.required),
    consent_forms: Yup.array()
        .of(optionObjectShape)
        .min(1, 'At least one consent form is required')
        .required(errorMessages?.required),
    appointment_type: Yup.object({
        label: Yup.string(),
        value: Yup.string().required(errorMessages?.required),
    }),
    clientType: Yup.object({
        label: Yup.string(),
        value: Yup.string().required(errorMessages?.required),
    }),
    clientId: Yup.object({
        label: Yup.string(),
        value: Yup.string().required(errorMessages?.required),
    }),
    assessment_services: Yup.array()
        .of(optionObjectShape)
        .min(1, 'At least one service is required')
        .required(errorMessages?.required),
    // clientResources: Yup.string().when('appointment_type', (appointmentType, schema) => {
    //     if (appointmentType?.value === 'funded') {
    //         return schema.required('Client resources are required when appointment type is funded');
    //     }
    //     return schema.notRequired();
    // }),
});

export default appointmentsValidationSchema;
